export default "__VITE_ASSET__COm9yUgA__"